import { ClickableText, Row, Text, useDesignTokens } from "@gradience/ui";
import { useNavigate } from "@tanstack/react-router";
import { useApiQuery } from "../../../../lib/api";
import { displayPaymentMethod } from "../../../../lib/display-payment-method";

/**
 * Shows which payment method a registration charge will go to, with a link to
 * change it.
 */
export const ChargedTo = () => {
  const school = useApiQuery("/school", {});
  const navigate = useNavigate({ from: "/$test-slug/home" });
  const designTokens = useDesignTokens();

  const paymentMethod = school.data?.paymentMethod;
  if (!paymentMethod) {
    return null;
  }

  return (
    <Row gap={8} style={{ alignItems: "center" }}>
      <Text textStyle="14px - Medium">
        Charged to {displayPaymentMethod(paymentMethod)}
      </Text>
      <ClickableText
        type="button"
        style={{ color: designTokens.colors.text.brand }}
        onClick={() => navigate({ search: { modal: "billing-method" as any } })}
      >
        Change
      </ClickableText>
    </Row>
  );
};
